
    <figure class="img-holder">
        <a [routerLink]="['/member-profile',friend.username,'Profile']">
            <img src="{{friend.profile_pic}}" class="dsp_img3 iviewed-img" alt="Shawn">
        </a>
        <div class="wpee-user-status wpee-online"></div>
    </figure>
    <div class="user-details">
        <h6 class="member-user-name">
            <a [routerLink]="['/member-profile',friend?.username,'Profile']">{{friend?.username}}</a>
            <span class="online dspdp-online-status">
                <span class="{{friend.isOnline==true?'dspdp-status-on':'dspdp-status-off'}}"></span>
            </span>
        </h6>
        <div class="user-detail-content">
            <p>
                {{friend.age}}
                <span><fa-icon [icon]="friend?.gender?.name === 'Male' ? famale : fafemale"></fa-icon></span>
                <br>
                {{friend?.country?.name}} {{friend?.city?.name}}
            </p>
        </div>
    </div>


   